// src/components/Dashboard.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import DisplayTickets from './DisplayTickets';
import { getPublicTickets, getMetrics, getCategoryMetrics } from '../api'; // Import the API function
import MetricsChart from './MetricsChart';

const Dashboard = ({ token }) => {
  const [publicTickets, setPublicTickets] = useState([]); // State to store public tickets
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [metrics, setMetrics] = useState({}); // State to store metrics data
  const [categoryMetrics, setCategoryMetrics] = useState({}); // State to store category metrics

  // Fetch public tickets, metrics, and category metrics when the component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch public tickets
        const ticketsResponse = await getPublicTickets();
        setPublicTickets(ticketsResponse.data);

        // Fetch metrics
        const metricsResponse = await getMetrics();
        setMetrics(metricsResponse.data);

        // Fetch category metrics
        const categoryMetricsResponse = await getCategoryMetrics();
        setCategoryMetrics(categoryMetricsResponse.data);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      } finally {
        setIsLoading(false); // Stop loading
      }
    };

    fetchData();
  }, []);

  return (
    <div className="w-full mx-auto">
      {/* Header with Create Ticket Button */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-white">Dashboard</h2>
        {/* <Link
          to="/create-ticket"
          className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 flex items-center gap-2"
        >
          Create Ticket
        </Link> */}
      </div>

      {/* Metrics Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <MetricCard title="Total Tickets" value={metrics.total_tickets || 0} />
        <MetricCard title="Resolved Tickets" value={metrics.resolved_tickets || 0} />
        <MetricCard title="Public Tickets" value={metrics.public_tickets || 0} />
        <MetricCard title="Private Tickets" value={metrics.private_tickets || 0} />
      </div>

      {/* Metrics Chart */}
      <div className="bg-[#1c1c24] p-6 flex flex-col items-center rounded-lg shadow-md mb-8">
        <h3 className="text-lg font-semibold text-white text-center mb-4">Ticket Status Overview</h3>
        <MetricsChart metrics={metrics} />
      </div>

      {/* Category Metrics Section */}
      <div className="bg-[#1c1c24] p-6 rounded-lg shadow-md mb-8">
        <h3 className="text-lg font-semibold text-white text-center mb-4">Tickets by Category</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {Object.keys(categoryMetrics).map((category) => (
            <CategoryCard key={category} category={category} count={categoryMetrics[category]} />
          ))}
        </div>
      </div>

      {/* Display Public Tickets */}
      <DisplayTickets
        title="Public Tickets"
        isLoading={isLoading}
        tickets={publicTickets}
      />
    </div>
  );
};

// Metric Card Component
const MetricCard = ({ title, value }) => {
  return (
    <div className="bg-[#1c1c24] p-6 rounded-lg shadow-md text-center">
      <h3 className="text-lg font-semibold text-white">{title}</h3>
      <p className="text-2xl font-bold text-green-500 mt-2">{value}</p>
    </div>
  );
};

// Category Card Component
const CategoryCard = ({ category, count }) => {
  return (
    <div className="bg-[#2a2a33] p-4 rounded-lg text-center">
      <h4 className="text-sm font-semibold text-white">{category}</h4>
      <p className="text-xl font-bold text-yellow-500 mt-2">{count}</p>
    </div>
  );
};

export default Dashboard;